import { render } from "./NotificationHeaderPane.vue?vue&type=template&id=3041ca9e&scoped=true&ts=true"
import script from "./NotificationHeaderPane.vue?vue&type=script&lang=ts"
export * from "./NotificationHeaderPane.vue?vue&type=script&lang=ts"

import "./NotificationHeaderPane.vue?vue&type=style&index=0&id=3041ca9e&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3041ca9e"]])

export default __exports__